import {
  digitalWellBeing,
  educatorDashboard,
  elementary,
  highSchool,
  middleSchool,
} from '../product/configs'

export const RouteContentProductAppMap = {
  learnOrphans: 'learnOrphans',
  learnFamilyResourcesHS: 'learnFamilyResourcesHS',
  learnFamilyResourcesK8: 'learnFamilyResourcesK8',
  learnDwbProduct: 'learnDwbProduct',
  learnMsProduct: 'learnMsProduct',
  learnHsProduct: 'learnHsProduct',
  learnK5Product: 'learnK5Product',
  learnEducatorDashboard: 'learnEducatorDashboard',
}

const buildProductSegments = product => [
  ...new Set([product.productName, ...(product.alternateNames ?? [])]),
]

const DIGITAL_ROUTE_PRODUCTS = [
  {
    appKey: RouteContentProductAppMap.learnK5Product,
    product: elementary,
  },
  {
    appKey: RouteContentProductAppMap.learnMsProduct,
    product: middleSchool,
  },
  {
    appKey: RouteContentProductAppMap.learnHsProduct,
    product: highSchool,
  },
  {
    appKey: RouteContentProductAppMap.learnDwbProduct,
    product: digitalWellBeing,
  },
  {
    appKey: RouteContentProductAppMap.learnEducatorDashboard,
    product: educatorDashboard,
  },
]

/**
 * Maps route-service app keys to curriculum service content group codes.
 */
export const AppToContentGroupCode = Object.fromEntries(
  DIGITAL_ROUTE_PRODUCTS.map(({ appKey, product }) => [
    appKey,
    product.contentGroupCode,
  ]),
)

/**
 * Maps route-service app keys to the URL product-name segments that
 * need stripping when forwarding paths to the curriculum service.
 */
export const AppToProductSegments = Object.fromEntries(
  DIGITAL_ROUTE_PRODUCTS.map(({ appKey, product }) => [
    appKey,
    buildProductSegments(product),
  ]),
)
